export class IntencaoConsultaResponseModel {
    constructor() { }

    public depositoId: string;
    public identificador: string;
    public agencia: string;
    public contaCorrente: string;
    public digitoContaCorrente: string;
    public nomeBanco: string;
    public codigoBanco: string;
    public valor: number;
    public dataCancelamento: Date | string | null;
    public dataProcessamento: Date | string | null;

    public Clear() {
        this.nomeBanco = '';
        this.agencia = '';
        this.valor = 0;
        this.codigoBanco = '';
        this.contaCorrente = '';
    }
}